<template>
  <div>
    <span
      class="error"
      v-for="(error) in errors[field]"
    >{{ error }} *</span>
  </div>
</template>

<script>
  export default {
      name: "validation-errors",
      props: {
          errors: {
              type: Object,
              default: new Object(),
          },
          field: {
              type: String,
              default: '',
          }
      },
  }
</script>
